import React, { useState, useCallback } from "react";
import styled from "styled-components";

import brk from "../../util/breakpoints";
import work from "../../data/work";
import interests from "../../data/interests";

import Container from "../Container";
import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import ProjectCard from "../ProjectCard";
import ProjectDetail, { hasDetail } from "../ProjectDetail";

const Wrapper = styled.section`
  width: 100%;
  padding: 104px 0;
  background: var(--bg);
  @media ${brk.device.tablet} {
    padding: 72px 0;
  }
`;

const TailorControl = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border: 1px solid var(--border);
  border-radius: 999px;
  outline: 1px solid transparent;
  outline-offset: -1px;
  background: var(--card);
  color: var(--textMuted);
  font-family: var(--fontMono);
  font-size: 10px;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  transition: outline-color 0.2s, color 0.2s;
  span {
    color: var(--purpleText);
  }
  &:hover {
    outline-color: var(--purple);
    color: var(--text);
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  margin-top: 44px;
  @media ${brk.device.tablet} {
    grid-template-columns: minmax(0, 1fr);
  }
`;

function Work(props) {
  const { interest, openTailorModal } = props;

  const [expandedItem, setExpandedItem] = useState(null);

  const closeDetail = useCallback(() => {
    setExpandedItem(null);
  }, []);

  const activeInterest = interests.find((item) => item.id === interest);
  const isTailored = Boolean(activeInterest) && interest !== "all";
  const matches = (item) => isTailored && item.interests.includes(interest);

  // Matching projects first; everything else keeps its original order.
  const orderedWork = isTailored
    ? [...work].sort((a, b) => Number(matches(b)) - Number(matches(a)))
    : work;

  return (
    <Wrapper id="work">
      {expandedItem && (
        <ProjectDetail item={expandedItem} onClose={closeDetail} />
      )}
      <Container>
        <Reveal>
          <SectionHeading label="02 / My work" title="My Work">
            <TailorControl onClick={openTailorModal}>
              {isTailored ? (
                <>
                  Tailored for <span>{activeInterest.label}</span> · Change
                </>
              ) : (
                "Tailor this for me"
              )}
            </TailorControl>
          </SectionHeading>
        </Reveal>
        <Grid>
          {orderedWork.map((item) => {
            return (
              <Reveal key={item.title}>
                <ProjectCard
                  title={item.title}
                  code={item.code}
                  tag={item.tag}
                  chipVariant={item.isSoftware ? "lime" : "purple"}
                  shortDesc={item.shortDesc}
                  url={item.url}
                  img={item.img}
                  highlighted={matches(item)}
                  onOpen={
                    hasDetail(item)
                      ? () => {
                          setExpandedItem(item);
                        }
                      : undefined
                  }
                />
              </Reveal>
            );
          })}
        </Grid>
      </Container>
    </Wrapper>
  );
}

export default Work;
